/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

export type SandboxErrorType = "NOT_OPEN" | "NOT_PUBLISHED" | "NO_PERMISSION" | "ALREADY_PUBLISHED" | "INVALID_FORK" | "NOT_SIGNEDIN" | "NOT_SIGNEDOUT" | "USERNAME_REQUIRED" | "SIGNIN_RENEW_FAILED" | "BUILD_FAILED" | "INVALID_LINK" | "UNKNOWN ERROR";

export enum SandboxErrorDefinition {
  "NOT_OPEN" = "No open sandbox available.",
  "NOT_PUBLISHED" = "Sandbox has not yet been published",
  "NO_PERMISSION" = "Current signed in user does not have permission",
  "ALREADY_PUBLISHED" = "Sandbox has already been published",
  "INVALID_FORK" = "Sandbox has not been forked correctly",
  "NOT_SIGNEDIN" = "User is not signed in",
  "NOT_SIGNEDOUT" = "User is not signed out",
  "SIGNIN_RENEW_FAILED" = "Sign in expired. Sign in again to continue.",
  "USERNAME_REQUIRED" = "A username is required",
  "BUILD_FAILED" = "The sandbox failed to build.",
  "INVALID_LINK" = "Invalid link format.",
  "UNKNOWN ERROR" = "An unknown error occurred."
}

export class SandboxError extends Error {
  public readonly type: SandboxErrorType;
  public readonly additionalMessages?: string[];
  public constructor(type: SandboxErrorType, additionalMessages?: string[]) {
    super(SandboxErrorDefinition[type]);
    this.type = type;
    this.additionalMessages = additionalMessages;
  }
}
